import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/Global.scss";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "@rollbar/react";
import ErrorBoundary from "./Components/Error/ErrorBoundary";

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: true,
  captureDeviceInfo: true,
  captureEmail: true,
  captureUsername: true,
  enabled: true,
  payload: {
    clientName: process.env.REACT_APP_NAME || "local",
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider config={rollbarConfig}>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>,
);
